/**
 * INE province code mapping used by address selectors.
 * Source naming follows INE option labels and includes common aliases.
 */
export const SPAIN_PROVINCE_ID_TO_NAME: Record<string, string> = {
  "1": "ARABA",
  "2": "ALBACETE",
  "3": "ALICANTE",
  "4": "ALMERIA",
  "5": "AVILA",
  "6": "BADAJOZ",
  "7": "ILLES BALEARS",
  "8": "BARCELONA",
  "9": "BURGOS",
  "10": "CACERES",
  "11": "CADIZ",
  "12": "CASTELLON",
  "13": "CIUDAD REAL",
  "14": "CORDOBA",
  "15": "A CORUÑA",
  "16": "CUENCA",
  "17": "GIRONA",
  "18": "GRANADA",
  "19": "GUADALAJARA",
  "20": "GIPUZKOA",
  "21": "HUELVA",
  "22": "HUESCA",
  "23": "JAEN",
  "24": "LEON",
  "25": "LLEIDA",
  "26": "LA RIOJA",
  "27": "LUGO",
  "28": "MADRID",
  "29": "MALAGA",
  "30": "MURCIA",
  "31": "NAVARRA",
  "32": "OURENSE",
  "33": "ASTURIAS",
  "34": "PALENCIA",
  "35": "LAS PALMAS",
  "36": "PONTEVEDRA",
  "37": "SALAMANCA",
  "38": "TENERIFE",
  "39": "CANTABRIA",
  "40": "SEGOVIA",
  "41": "SEVILLA",
  "42": "SORIA",
  "43": "TARRAGONA",
  "44": "TERUEL",
  "45": "TOLEDO",
  "46": "VALENCIA",
  "47": "VALLADOLID",
  "48": "BIZKAIA",
  "49": "ZAMORA",
  "50": "ZARAGOZA",
  "51": "CEUTA",
  "52": "MELILLA",
};

/** Exact province dropdown list requested by product/data source. */
export const SPAIN_PROVINCE_DROPDOWN_OPTIONS: Array<{ id: string; name: string }> = [
  { id: "15", name: "A CORUÑA" },
  { id: "2", name: "ALBACETE" },
  { id: "3", name: "ALICANTE" },
  { id: "4", name: "ALMERIA" },
  { id: "1", name: "ARABA" },
  { id: "33", name: "ASTURIAS" },
  { id: "5", name: "AVILA" },
  { id: "6", name: "BADAJOZ" },
  { id: "8", name: "BARCELONA" },
  { id: "48", name: "BIZKAIA" },
  { id: "9", name: "BURGOS" },
  { id: "10", name: "CACERES" },
  { id: "11", name: "CADIZ" },
  { id: "39", name: "CANTABRIA" },
  { id: "12", name: "CASTELLON" },
  { id: "51", name: "CEUTA" },
  { id: "13", name: "CIUDAD REAL" },
  { id: "14", name: "CORDOBA" },
  { id: "16", name: "CUENCA" },
  { id: "20", name: "GIPUZKOA" },
  { id: "17", name: "GIRONA" },
  { id: "18", name: "GRANADA" },
  { id: "19", name: "GUADALAJARA" },
  { id: "21", name: "HUELVA" },
  { id: "22", name: "HUESCA" },
  { id: "7", name: "ILLES BALEARS" },
  { id: "23", name: "JAEN" },
  { id: "26", name: "LA RIOJA" },
  { id: "35", name: "LAS PALMAS" },
  { id: "24", name: "LEON" },
  { id: "25", name: "LLEIDA" },
  { id: "27", name: "LUGO" },
  { id: "28", name: "MADRID" },
  { id: "29", name: "MALAGA" },
  { id: "52", name: "MELILLA" },
  { id: "30", name: "MURCIA" },
  { id: "31", name: "NAVARRA" },
  { id: "32", name: "OURENSE" },
  { id: "34", name: "PALENCIA" },
  { id: "36", name: "PONTEVEDRA" },
  { id: "37", name: "SALAMANCA" },
  { id: "40", name: "SEGOVIA" },
  { id: "41", name: "SEVILLA" },
  { id: "42", name: "SORIA" },
  { id: "43", name: "TARRAGONA" },
  { id: "38", name: "TENERIFE" },
  { id: "44", name: "TERUEL" },
  { id: "45", name: "TOLEDO" },
  { id: "46", name: "VALENCIA" },
  { id: "47", name: "VALLADOLID" },
  { id: "49", name: "ZAMORA" },
  { id: "50", name: "ZARAGOZA" },
];

function norm(v: string): string {
  return String(v || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toUpperCase();
}

const provinceAliases: Record<string, string> = {
  "ALAVA": "1",
  "ARABA": "1",
  "A CORUNA": "15",
  "LA CORUNA": "15",
  "CORUNA": "15",
  "GERONA": "17",
  "GIRONA": "17",
  "GUIPUZCOA": "20",
  "GIPUZKOA": "20",
  "LERIDA": "25",
  "LLEIDA": "25",
  "ORENSE": "32",
  "OURENSE": "32",
  "VIZCAYA": "48",
  "BIZKAIA": "48",
  "SANTA CRUZ DE TENERIFE": "38",
  "TENERIFE": "38",
  "ISLAS BALEARES": "7",
  "ILLES BALEARS": "7",
};

Object.entries(SPAIN_PROVINCE_ID_TO_NAME).forEach(([id, name]) => {
  provinceAliases[norm(name)] = id;
});

export function getSpainProvinceIdByName(name: string): string | null {
  const key = norm(name);
  if (!key) return null;
  return provinceAliases[key] || null;
}

